import { IconButton, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { FiMoreVertical } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { FuncionariosOptionsMenu } from "./FuncionariosOptionsMenu";

export function FuncionariosRow({ row }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePermissions = () => {
    history.push(`/configuracoes/funcionarios/permissoes/${row.id}`);
    handleClose();
  };

  return (
    <>
      <TableRow>
        <TableCell sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>{row.id}</TableCell>
        <TableCell sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>{row.codRad}</TableCell>
        <TableCell sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>{row.base}</TableCell>
        <TableCell sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>{row.nome}</TableCell>
        <TableCell sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>
          <IconButton
            aria-controls={openMenu ? "funcionario-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openMenu ? "true" : undefined}
            onClick={handleClick}
          >
            <FiMoreVertical />
          </IconButton>
        </TableCell>
      </TableRow>

      <FuncionariosOptionsMenu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        onPermissions={handlePermissions}
      />
    </>
  );
}
